import { Container, Col, Row } from "react-bootstrap";
import "../Homepage/homepage.css";
import Footer from "../../components/Layout/Footer/Footer";
import Jumbotron from "../../components/Layout/Jumbotron/Jumbotron";
import ScheduleII from "../../components/Layout/Schedule/ScheduleII";
import Video from "../../components/Layout/Video/Video";
import Instagram from "../../components/Layout/SocialMediaFeed/Instagram";

const Homepage = () => {
  return (
    <div>
      <Jumbotron />
      <Container fluid>
        <Row>
          <Col>
            <ScheduleII />
          </Col>
        </Row>
        <Row>
          <Col>
            <Video />
          </Col>
        </Row>
        <Row>
          <Col>
            <Instagram />
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default Homepage;
